import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from 'app/_services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

export const errorInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const _authService = inject(AuthService);
  const _router = inject(Router);
  const _snackBar = inject(MatSnackBar);
  return next(req).pipe(
    catchError((err) => {
      if (req.url.includes('forgotmobileuserpassword') || req.url.includes('forgotmobileuserpasswordcomplete')) {
        const error = err;
        return throwError(error);
      }
      if (err.status === 401) {
        _authService.signOut();
        let redirectURL = _router.url;
        if (redirectURL.includes('sign-in')) {
          if (!_authService.isProduction) _router.navigate(['sign-in']);
          else window.open(`https://${window.location.hostname}/auth/sign-in`, '_self');
        } else if (redirectURL == '/') {
          redirectURL = branding();
          if (!_authService.isProduction)
            _router.navigate(['sign-in'], {
              queryParams: { redirectURL },
            });
          else window.open(`https://${window.location.hostname}/auth/sign-in?redirectURL=${redirectURL}`, '_self');
        } else {
          if (!_authService.isProduction)
            _router.navigate(['sign-in'], {
              queryParams: { redirectURL },
            });
          else window.open(`https://${window.location.hostname}/auth/sign-in?redirectURL=${redirectURL}`, '_self');
        }
      } else if (err.status === 500) {
        if (!req.url.includes('forgotpassword') && !req.url.includes('reset-password')) {
          _snackBar.open('An Error occurred while processing your request, Please try again later!.', 'close', {
            duration: 3000,
            panelClass: 'errorSnack',
            horizontalPosition: 'right',
            verticalPosition: 'top',
          });
        }
      } else if (err.status === 400) {
        console.log('err', err);
        if (err.error.errors) {
          const firstErrorKey = Object.keys(err.error.errors)[0];
          const firstErrorMessage = err.error.errors[firstErrorKey][0];

          _snackBar.open(firstErrorMessage, 'close', {
            duration: 3000,
            panelClass: 'errorSnack',
            horizontalPosition: 'right',
            verticalPosition: 'top',
          });
        } else {
          _snackBar.open(err.error.detail, 'close', {
            duration: 3000,
            panelClass: 'errorSnack',
            horizontalPosition: 'right',
            verticalPosition: 'top',
          });
        }
      } else if (err.status === 403) {
        _snackBar.open('Access Denied!', 'close', {
          duration: 3000,
          panelClass: 'errorSnack',
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
      }
      const error = err;
      return throwError(error);
    })
  );
};
const branding = () => {
  // brand = window.location.hostname.replace(/\./g, '');
  let brand = window.location.hostname.split('.');

  return brand[0].includes('fieldpal') ? '/signed-in-redirect' : 'home';
  //return true;
};
